import groupCard from '@/components/card/GroupCard'
import textCard from '@/components/card/TextCard'
import companyProfileCard from '@/components/card/CompanyProfileCard'
import jobHistoryCard from '@/components/card/JobHistoryCard'
import nameAddressCard from '@/components/card/NameAddressCard'
import frontPageCard from '@/components/card/FrontPageCard'
import dateCard from '@/components/card/DateCard'
import manageExperienceCard from '@/components/card/ManageExperienceCard'
import licenceCard from '@/components/card/LicenceCard'
import stakeholdersCard from '@/components/card/StakeholdersCard'
import customTextCard from '@/components/card/CustomTextCard'
import customImageCard from '@/components/card/CustomImageCard'
import borrowerCard from '@/components/card/BorrowerCard'
import manpowerPlanningCard from '@/components/card/ManpowerPlanningCard'

import groupCardPreview from '@/components/card/GroupCardPreview'
import textCardPreview from '@/components/card/TextCardPreview'
import companyProfileCardPreview from '@/components/card/CompanyProfileCardPreview'
import jobHistoryCardPreview from '@/components/card/JobHistoryCardPreview'
import nameAddressCardPreview from '@/components/card/NameAddressCardPreview'
import frontPageCardPreview from '@/components/card/FrontPageCardPreview'
import dateCardPreview from '@/components/card/DateCardPreview'
import manageExperienceCardPreview from '@/components/card/ManageExperienceCardPreview'
import licenceCardPreview from '@/components/card/LicenceCardPreview'
import stakeholdersCardPreview from '@/components/card/StakeholdersCardPreview'
import customTextCardPreview from '@/components/card/CustomTextCardPreview'
import customImageCardPreview from '@/components/card/CustomImageCardPreview'
import borrowerCardPreview from '@/components/card/BorrowerCardPreview'
import manpowerPlanningCardPreview from '@/components/card/ManpowerPlanningCardPreview'

const cardIndex = {
  'groupCard': { edit: groupCard, preview: groupCardPreview },
  'textCard': { edit: textCard, preview: textCardPreview },
  'jobHistoryCard': { edit: jobHistoryCard, preview: jobHistoryCardPreview },
  'companyProfileCard': { edit: companyProfileCard, preview: companyProfileCardPreview },
  'nameAddressCard': { edit: nameAddressCard, preview: nameAddressCardPreview },
  'frontPageCard': { edit: frontPageCard, preview: frontPageCardPreview },
  'dateCard': { edit: dateCard, preview: dateCardPreview },
  'manageExperienceCard': { edit: manageExperienceCard, preview: manageExperienceCardPreview },
  'licenceCard': { edit: licenceCard, preview: licenceCardPreview },
  'stakeholdersCard': { edit: stakeholdersCard, preview: stakeholdersCardPreview },
  'customTextCard': { edit: customTextCard, preview: customTextCardPreview },
  'customImageCard': { edit: customImageCard, preview: customImageCardPreview },
  'borrowerCard': { edit: borrowerCard, preview: borrowerCardPreview },
  'manpowerPlanningCard': { edit: manpowerPlanningCard, preview: manpowerPlanningCardPreview }
}

export default cardIndex
